'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEmpty = exports.onKeys = exports.formatMoney = exports.removeClass = exports.addClass = exports.cacheFlowVariants = exports.handlize = exports.toggleElement = exports.getAlternativeTemplate = exports.isNumber = exports.getChildContainers = exports.getParentContainers = exports.getContainer = exports.getAlternativeTemplate2 = exports.setSearchParm = exports.getSearchParm = exports.getHandle = exports.constCase = exports.debounce = exports.unique = exports.random = exports.priceString = exports.$$ = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

require('whatwg-fetch');

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-undef */
var $$ = exports.$$ = function $$(selector) {
  var nodes = document.querySelectorAll(selector);

  return Array.from(nodes);
};

var priceString = exports.priceString = function priceString(priceInCents) {
  var withCents = (priceInCents / 100).toFixed(2);
  var amount = withCents.includes('.00') ? withCents.split('.')[0] : withCents;

  return '$' + amount;
};

var random = exports.random = function random() {
  var digits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 9;

  return Math.floor(Math.random() * Math.pow(10, digits));
};

var unique = exports.unique = function unique(array) {
  return [].concat((0, _toConsumableArray3.default)(new Set(array)));
};

var debounce = exports.debounce = function debounce(callback) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;
  var interval = arguments[2];
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(interval);
    // eslint-disable-next-line no-param-reassign
    interval = setTimeout(function () {
      return callback.apply(undefined, args);
    }, time);
  };
};

var constCase = exports.constCase = function constCase(string) {
  return string.trim().toUpperCase().replace(/[\s-]/g, '_');
};

var getHandle = exports.getHandle = function getHandle() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'product';

  if (type === 'collection') {
    return window.location.pathname.replace(/\/collections\/(.*)\/?/, '$1');
  } else if (type === 'product') {
    return window.location.pathname.replace(/\/products\/(.*)\/?/, '$1');
  }
  return window.location.pathname.replace(/\/products\/(.*)\/?/, '$1');
};

var getSearchParm = exports.getSearchParm = function getSearchParm(params) {
  var searchParams = new URLSearchParams(window.location.search);

  return typeof params === 'string' ? searchParams.get(params) : params.reduce(function (params, param) {
    return Object.assign({}, params, (0, _defineProperty3.default)({}, param, searchParams.get(param.toLowerCase())));
  }, {});
};

var setSearchParm = exports.setSearchParm = function setSearchParm(param, value) {
  var searchParams = new URLSearchParams(window.location.search);

  searchParams.set(param, value);
  window.history.pushState('', '', '?' + searchParams.toString());
  return searchParams;
};

// export const getAlternativeTemplate2 = ({ resource, templateName, json = true }) => {
//   const url = `/${resource}?view=${templateName}`;
//   const options = { credentials: 'include' };

//   return jQuery.get(url).then(res => {
//     console.log('res222', res);

//     return res;
//   })
//   .then(res => (json) ? JSON.parse(res) : res);
// };

var getAlternativeTemplate2 = exports.getAlternativeTemplate2 = function getAlternativeTemplate2(_ref) {
  var resource = _ref.resource,
      templateName = _ref.templateName,
      _ref$json = _ref.json,
      json = _ref$json === undefined ? false : _ref$json;

  var url = '/' + resource + '?view=' + templateName;
  var options = { credentials: 'include' };

  return fetch(url, options).then(function (res) {
    return json ? res.json() : res.text();
  });
};

var getContainer = exports.getContainer = function getContainer(_ref2) {
  var self = _ref2.self,
      type = _ref2.type,
      id = _ref2.id,
      name = _ref2.name,
      _ref2$asjQuery = _ref2.asjQuery,
      asjQuery = _ref2$asjQuery === undefined ? false : _ref2$asjQuery;

  if (id) {
    return asjQuery ? $('[data-container-id="' + id + '"]') : $('[data-container-id="' + id + '"]')[0];
  } else if (name) {
    return asjQuery ? $('[data-container-name="' + name + '"]') : $('[data-container-name="' + name + '"]')[0];
  } else if (self && type) {
    return asjQuery ? $(self).closest('[data-container="' + type + '"]') : $(self).closest('[data-container="' + type + '"]')[0];
  } else if (type) {
    return asjQuery ? $('[data-container="' + type + '"]') : $('[data-container="' + type + '"]').get();
  } else if (self) {
    return asjQuery ? $(self).closest(_Dom2.default.container) : $(self).closest(_Dom2.default.container)[0];
  }

  return asjQuery ? $(_Dom2.default.container) : $(_Dom2.default.container).get();
};

var getParentContainers = exports.getParentContainers = function getParentContainers(_ref3) {
  var self = _ref3.self,
      _ref3$asjQuery = _ref3.asjQuery,
      asjQuery = _ref3$asjQuery === undefined ? false : _ref3$asjQuery,
      _ref3$containers = _ref3.containers,
      containers = _ref3$containers === undefined ? {} : _ref3$containers;

  var $container = getContainer({ self: self, asjQuery: true });

  if ($container.length === 0) return containers;

  var node = $container[0];
  var _node$dataset = node.dataset,
      type = _node$dataset.container,
      id = _node$dataset.containerId,
      name = _node$dataset.containerName;

  var containerData = asjQuery ? { id: id, name: name, node: $(node) } : { id: id, name: name, node: node };
  var parentContainers = Object.assign({}, containers, (0, _defineProperty3.default)({}, type, containerData));

  return getParentContainers({ self: $container.parent()[0], containers: parentContainers });
};

var getChildContainers = exports.getChildContainers = function getChildContainers(_ref4) {
  var self = _ref4.self,
      asjQuery = _ref4.asjQuery;

  return $(self).find(_Dom2.default.container).get().reduce(function (containers, node) {
    var _node$dataset2 = node.dataset,
        type = _node$dataset2.container,
        id = _node$dataset2.containerId,
        name = _node$dataset2.containerName;

    var containerData = asjQuery ? { id: id, name: name, node: $(node) } : { id: id, name: name, node: node };

    return Object.assign({}, containers, (0, _defineProperty3.default)({}, type, [].concat((0, _toConsumableArray3.default)(containers[type] || []), [containerData])));
  }, {});
};

var isNumber = exports.isNumber = function isNumber(input) {
  return !isNaN(Number(input));
};

// Helpers from the old codebase

var getAlternativeTemplate = exports.getAlternativeTemplate = function getAlternativeTemplate(resource, templateName) {
  var json = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var url = '/' + resource + '?view=' + templateName;
  // console.log('>>', url);
  var options = { credentials: 'include' };
  return fetch(url, options).then(function (res) {
    return json ? res.json() : res.text();
  });
};

var toggleElement = exports.toggleElement = function toggleElement(_ref5) {
  var selector = _ref5.selector,
      _ref5$className = _ref5.className,
      className = _ref5$className === undefined ? _Dom2.default.isActive : _ref5$className,
      _ref5$action = _ref5.action,
      action = _ref5$action === undefined ? 'toggle' : _ref5$action,
      _ref5$animated = _ref5.animated,
      animated = _ref5$animated === undefined ? false : _ref5$animated;

  var normalizedclassName = className[0] === '.' ? className.slice(1) : className;
  var normalizedSelectorString = className[0] !== '.' ? '.' + className : className;

  var impossibleAdd = $(selector).is(normalizedSelectorString) && action == 'add';
  var impossibleRemove = !$(selector).is(normalizedSelectorString) && action == 'remove';

  if (impossibleAdd || impossibleRemove) {
    return Promise.resolve({});
  }

  var toggleClass = function toggleClass() {
    if (action === 'toggle') {
      $(selector).toggleClass(normalizedclassName);
    } else if (action === 'add') {
      $(selector).addClass(normalizedclassName);
    } else if (action === 'remove') {
      $(selector).removeClass(normalizedclassName);
    }
  };

  if (animated) {
    return new Promise(function (resolve) {
      $(selector).one('transitionend', function () {
        return resolve({ selector: selector, className: className, action: action, animated: animated });
      });
      toggleClass();
    });
  }

  toggleClass();

  return Promise.resolve({ selector: selector, className: className, action: action, animated: animated });
};

var handlize = exports.handlize = function handlize(string) {
  return string.toLowerCase().replace(/['"]/g, '-') // Replace ' with -
  .replace(/\s+/g, '-') // Replace spaces with -
  .replace(/\//g, '-') // Replace all / with -
  .replace(/[^\w\-]+/g, '') // Remove all non-word chars
  .replace(/\-\-+/g, '-') // Replace multiple - with single -
  .replace(/^-+/, '') // Trim - from start of text
  .replace(/-+$/, ''); // Trim - from end of text
};

var cacheFlowVariants = exports.cacheFlowVariants = function cacheFlowVariants(selector, attr) {
  var variantIds = $(selector).map(function (index, item) {
    return $(item).attr(attr);
  });

  Flow.set('on', 'ready', function () {
    if (Flow && Flow.cart && Flow.getExperience()) {
      Flow.variants.load({
        variants: variantIds,
        experience: Flow.getExperience(),
        // eslint-disable-next-line no-unused-vars
        success: function success(status, variants) {
          // console.info('variants',variants);
        },
        error: function error(_error) {
          console.log('error', _error);
        }
      });
    }
  });
};

var addClass = exports.addClass = function addClass(el, className) {
  if (!new RegExp(className).test(el.className)) {
    el.className += ' ' + className;
  }
};

var removeClass = exports.removeClass = function removeClass(el, className) {
  if (new RegExp(className).test(el.className)) {
    el.className = el.className.replace(className, '');
  }
};

var formatMoney = exports.formatMoney = function formatMoney(cents) {
  return '<span class="money">$' + (cents / 100).toFixed(2).replace('.00', '') + '</span>';
};

/**
 * @param {Array<Number>} keys - keycodes to trigger the function
 * @param {Function} fn - function to be called
 * @return {Function} - event handler
 *
 * @example window.addEventListener('keyup', onKeys([13, 27], onEnterOrEscape))
 */
var onKeys = exports.onKeys = function onKeys(keys, fn) {
  return function (event) {
    if (keys.includes(event.which)) {
      fn(event);
    }
  };
};

var isEmpty = exports.isEmpty = function isEmpty(el) {
  return !$.trim(el.html());
};